export default "__VITE_ASSET__bb3bc6f5__"